/* eslint-disable */

import React, { createContext, useContext, useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

interface PublicConfigState {
  publicConfig: { [key: string]: any };
}
const PublicConfigContext = createContext<PublicConfigState>({
  publicConfig: {},
});

interface PublicConfigProps {
  apiHost: string;
  children: any;
  waitForConfig?: boolean;
}
const PublicConfig = ({ apiHost, children, waitForConfig = true }: PublicConfigProps) => {
  const [publicConfig, setPublicConfig] = useState<
    PublicConfigState['publicConfig']
  >({});

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(`${apiHost}/public_config`, {
          method: 'GET',
          headers: {
            accept: 'application/json',
          },
        });

        const json = await response.json();
        setPublicConfig(json);
      } catch (error) {
        console.error(error);
      }
    };
    load();
  }, [apiHost]);

  const value = { publicConfig };
  if (waitForConfig && isEmpty(publicConfig)) {
    return null;
  }

  return (
    <PublicConfigContext.Provider value={value}>
      {children}
    </PublicConfigContext.Provider>
  );
};

export const usePublicConfig = () => useContext(PublicConfigContext);

export default PublicConfig;
